import { Core } from "@faire/design-tokens";
import { IDocument } from "@faire/web-api/indigofair/data/IDocument";
import { useStrictLocalization } from "@faire/web/common/localization";
import { FileUploader } from "@faire/web/slate/FileUploader";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React, { FC } from "react";

import { OwFFormFieldKey } from "./consts";

interface IProps {
  value: IDocument[];
  onChange: (files: IDocument[]) => void;
  error?: boolean;
  fieldName: OwFFormFieldKey;
}

export const OwFFileUploader: FC<IProps> = ({
  value,
  onChange,
  error,
  fieldName,
}) => {
  const { strictLocalize } = useStrictLocalization();

  return (
    <>
      {error ? (
        <>
          <Typography color={Core.text.critical}>
            <StrictLocalMsg
              defaultMessage="Required"
              description={{
                text: "Indicate the field in a form is required",
              }}
            />
          </Typography>
          <Spacer height="1x" />
        </>
      ) : null}
      <FileUploader
        acceptedFileTypes={[
          "image/jpeg",
          "image/png",
          "application/pdf",
          ".jpeg",
          ".jpg",
          ".png",
          ".pdf",
        ]}
        acceptMessage={strictLocalize({
          defaultMessage: "Accepts: JPG, PNG, or PDF",
          description: {
            text: "Lists the filetypes that a file uploading component expects.",
            img: "https://cdn.faire.com/fastly/6b4625043c3ed5e6b5b68fa7119c663ba25d7b8ddde9eb1fbc0fa6237c8ed489.png",
          },
        })}
        documents={value}
        setDocuments={onChange}
        data-test-id={fieldName}
      />
    </>
  );
};
